import IncomesList from "./IncomesList";

export default IncomesList;
